import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'syslink-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent extends InputComponent { }
